/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Input, ModalHeader, ModalBody, ModalFooter, Button, Select, SelectItem, Divider, User } from '@nextui-org/react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { getOnlyNumbers, formatNumericFields, fromPhotos, Constants } from '../../../utils';
import { IconImageEdit } from '../../../assets/icons';
import { IconEye, IconEyeOff, IconPlus } from '@tabler/icons-react';
import { UsersService, TeacherStudentSerivce } from '../../../services';
import DebouncedSearch from '../../../components/input-debounce';
import CountryFlag from '../../../components/country-flag';


const ModalCreateParent = ({ user, onSuccess, onClose }) => {
  const [resetDebounce, setResetDebounce] = useState(false);
  const { addParent, form, onChange, onSubmit, parents, phoneCodes, documentTypes, relationships, currentUser, debounceValue, genders } = useForm(user);
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => setIsVisible(!isVisible);

  const submit = async () => {
    const isSuccess = await onSubmit();
    if (isSuccess) onSuccess();
  }

  const searchResult = (item) => {
    if (!item) {
      onChange('', 'parent_id')
      onChange('', 'parent_name')
      onChange('', 'parent_lastname')
      onChange('', 'parent_document_type_id')
      onChange('', 'parent_document')
      onChange('', 'parent_phonecode_id')
      onChange('', 'parent_phone')
      onChange('', 'parent_birthdate')
      onChange('', 'parent_email')
      onChange('', 'parent_relationship')
      return
    }
    onChange(item.id, 'parent_id')
    onChange(item.name, 'parent_name')
    onChange(item.lastname, 'parent_lastname')
    onChange(item.document_type_id.toString(), 'parent_document_type_id')
    onChange(getOnlyNumbers(item.document), 'parent_document')
    onChange(item.phonecode_id.toString(), 'parent_phonecode_id')
    onChange(item.phone, 'parent_phone')
    onChange(item.birthdate, 'parent_birthdate')
    onChange(item.email, 'parent_email')
  }

  const filterParents = async (query) => {
    const text = query.trim().toLowerCase();
    if (!text) return [];
    const response = await TeacherStudentSerivce.student.getRepresentatives({ search: text, user_id: currentUser.id });
    const data = response.filter(item => !parents.find(x => x.id === item.id));
    return data;
  }

  const visibilityBtn = (
    <button className="focus:outline-none" type="button" onClick={toggleVisibility}>
      {isVisible ? (
        <IconEyeOff className="w-6 h-6" />
      ) : (
        <IconEye className="w-6 h-6" />
      )}
    </button>
  )


  return (
    <>
      <ModalHeader className="flex flex-col gap-1">{!!user ? 'Editar' : 'Nuevo'}</ModalHeader>
      <ModalBody className="gap-8">
        <div className="flex items-center justify-start">
          <label htmlFor="photo" className="cursor-pointer text-center border-2 border-gray w-16 h-16 rounded-lg flex justify-center items-center self-center overflow-hidden">
            {!!form.photoUrl ? (
              <img className="w-full h-full object-cover" src={form.photoUrl} alt="Foto del colegio" />
            ) : (
              <img className="w-12 object-contain opacity-50" src={IconImageEdit} alt="Foto del colegio" />
            )}
            <input
              id="photo"
              type="file"
              accept="image/*"
              hidden
              onChange={e => onChange(e.target.files[0], 'photo')}
            />
          </label>

          <div className="flex flex-col ml-4 text-sm">
            <span className="font-medium leading-3">Subir foto de perfil</span>
            <span>(Tipo carnet y fondo gris)</span>
          </div>
        </div>

        <div className="flex flex-col flex-1 gap-4">
          <div className="grid grid-cols-3 gap-4">
            <Input
              label="Nombre"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              value={form.name}
              onValueChange={v => onChange(v, 'name')}
            />
            <Input
              label="Apellido"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              value={form.lastname}
              onValueChange={v => onChange(v, 'lastname')}
            />
            <Input
              label="DNI/C.I"
              labelPlacement="outside"
              placeholder=" "
              startContent={(
                <Select
                  aria-label="Tipo de documento"
                  variant="flat"
                  classNames={{ trigger: 'border-0 max-w-24' }}
                  disallowEmptySelection={true}
                  selectedKeys={!!form.document_type_id ? [form.document_type_id] : []}
                  onSelectionChange={v => onChange(v.currentKey, 'document_type_id')}
                >
                  {documentTypes.map((item) => (
                    <SelectItem key={item.value} value={item.value}>
                      {item.label}
                    </SelectItem>
                  ))}
                </Select>
              )}
              variant="bordered"
              radius="sm"
              classNames={{ innerWrapper: 'overflow-hidden', inputWrapper: 'pl-0' }}
              value={form.document}
              onValueChange={v => onChange(getOnlyNumbers(v), 'document')}
              maxLength={15}
            />
          </div>

          <div className="grid grid-cols-3 gap-4">
            {/* <Input
              label="Teléfono"
              labelPlacement="outside"
              placeholder=" "
              startContent={(
                <Select
                  aria-label="Código de área"
                  variant="flat"
                  classNames={{ trigger: 'border-0 max-w-24' }}
                  disallowEmptySelection={true}
                  selectedKeys={!!form.phonecode_id ? [form.phonecode_id] : []}
                  onSelectionChange={v => onChange(v.currentKey, 'phonecode_id')}
                >
                  {phoneCodes.map((item) => (
                    <SelectItem key={item.value} value={item.value}>
                      <img
                        src={Constants.BASENAME + item.url}
                        alt={item.label}
                        style={{ width: 20, height: 14, objectFit: 'cover', marginRight: 6, borderRadius: 2 }}
                      />
                      {item.label}
                    </SelectItem>
                  ))}
                </Select>
              )}
              variant="bordered"
              radius="sm"
              classNames={{ innerWrapper: 'overflow-hidden', inputWrapper: 'pl-0' }}
              value={form.phone}
              onValueChange={v => onChange(getOnlyNumbers(v), 'phone')}
              maxLength={12}
            /> */}
            <Input
              label="Teléfono"
              labelPlacement="outside"
              placeholder=" "
              startContent={(
                <Select
                  aria-label="Código de área"
                  variant="flat"
                  classNames={{ trigger: 'border-0 max-w-28 pl-1 pr-0' }}
                  disallowEmptySelection={true}
                  selectedKeys={(!!form.phonecode_id && !!phoneCodes.length) ? [form.phonecode_id] : []}
                  onSelectionChange={v => onChange(v.currentKey, 'phonecode_id')}
                  startContent={<CountryFlag phoneCodeId={form.phonecode_id} phoneCodes={phoneCodes} />}
                >
                  {phoneCodes.map((item) => (
                    <SelectItem
                      key={item.value}
                      value={item.value}
                      startContent={<CountryFlag src={item.url} />}
                      classNames={{ title: 'min-w-48' }}
                    >
                      {item.label}
                    </SelectItem>
                  ))}
                </Select>
              )}
              variant="bordered"
              radius="sm"
              classNames={{ innerWrapper: 'overflow-hidden', inputWrapper: 'pl-0' }}
              value={form.phone}
              onValueChange={v => onChange(getOnlyNumbers(v), 'phone')}
              maxLength={12}
            />

            <Input
              label="Correo electrónico"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              value={form.email}
              onValueChange={v => onChange(v, 'email')}
            />
            <Select
              label="Género"
              labelPlacement="outside"
              placeholder=" "
              variant="bordered"
              radius="sm"
              classNames={{ label: 'font-semibold' }}
              disallowEmptySelection={true}
              selectedKeys={!!form.gender_id ? [form.gender_id] : []}
              onSelectionChange={v => onChange(v.currentKey, 'gender_id')}
            >
              {genders.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </Select>
          </div>


          <Divider />


          <div>
            <h6 className="text-primary font-bold mb-2">Representantes</h6>
            <div className='mt-4 mb-7'>
              {
                !user && (
                  <DebouncedSearch
                    refresh={resetDebounce}
                    label=''
                    fetchFunction={filterParents}
                    debounceTime={700}
                    onSelect={searchResult}
                    renderItem={(item) => `${item.fullname} (${item.document_type?.name}${item.document})`}
                    onClickLabel={(item) => item.fullname}
                    value={debounceValue}
                    placeholder='Buscar representante'
                  />
                )
              }
            </div>
            <div className="grid grid-cols-3 gap-4">
              <Input
                label="Nombre"
                labelPlacement="outside"
                placeholder=" "
                radius="sm"
                variant="bordered"
                value={form.parent_name}
                onValueChange={v => onChange(v, 'parent_name')}
              />
              <Input
                label="Apellido"
                labelPlacement="outside"
                placeholder=" "
                radius="sm"
                variant="bordered"
                value={form.parent_lastname}
                onValueChange={v => onChange(v, 'parent_lastname')}
              />
              <Input
                label="DNI/C.I"
                labelPlacement="outside"
                placeholder=" "
                startContent={(
                  <Select
                    aria-label="Tipo de documento"
                    variant="flat"
                    classNames={{ trigger: 'border-0 max-w-28 h-10' }}
                    disallowEmptySelection={true}
                    selectedKeys={!!form.parent_document_type_id ? [form.parent_document_type_id] : []}
                    onSelectionChange={v => onChange(v.currentKey, 'parent_document_type_id')}
                  >
                    {documentTypes.map((item) => (
                      <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
                    ))}
                  </Select>
                )}
                variant="bordered"
                radius="sm"
                classNames={{ innerWrapper: 'overflow-hidden', inputWrapper: 'pl-0' }}
                value={form.parent_document}
                onValueChange={v => onChange(getOnlyNumbers(v), 'parent_document')}
                maxLength={15}
              />
              <Input
                label="Correo electrónico"
                labelPlacement="outside"
                placeholder=" "
                radius="sm"
                variant="bordered"
                value={form.parent_email}
                onValueChange={v => onChange(v, 'parent_email')}
              />
              <Input
                type="date"
                classNames={{
                  input: `pr-0 text-${!!form.parent_birthdate ? '[]' : 'foreground-400'}`,
                }}
                label="Fecha de nacimiento"
                labelPlacement="outside"
                placeholder=" "
                variant="bordered"
                radius="sm"
                value={form.parent_birthdate}
                onValueChange={v => onChange(v, 'parent_birthdate')}
              />
              <Input
                label="Teléfono"
                labelPlacement="outside"
                placeholder=" "
                startContent={(
                  <Select
                    aria-label="Código de área"
                    variant="flat"
                    classNames={{ trigger: 'border-0 max-w-28 pl-1 pr-0' }}
                    disallowEmptySelection={true}
                    selectedKeys={(!!form.parent_phonecode_id && !!phoneCodes.length) ? [form.parent_phonecode_id] : []}
                    onSelectionChange={v => onChange(v.currentKey, 'parent_phonecode_id')}
                    startContent={<CountryFlag phoneCodeId={form.phonecode_id} phoneCodes={phoneCodes} />}
                  >
                    {phoneCodes.map((item) => (
                      <SelectItem
                        key={item.value}
                        value={item.value}
                        startContent={<CountryFlag src={item.url} />}
                        classNames={{ title: 'min-w-48' }}
                      >
                        {item.label}
                      </SelectItem>
                    ))}
                  </Select>
                )}
                variant="bordered"
                radius="sm"
                classNames={{ innerWrapper: 'overflow-hidden', inputWrapper: 'pl-0' }}
                value={form.parent_phone}
                onValueChange={v => onChange(getOnlyNumbers(v), 'parent_phone')}
              />
              <Select
                label="Parentesco"
                labelPlacement="outside"
                placeholder=" "
                variant="bordered"
                radius="sm"
                classNames={{ label: 'font-semibold' }}
                disallowEmptySelection
                selectedKeys={!!form.parent_relationship ? [form.parent_relationship] : []}
                onSelectionChange={v => onChange(v.currentKey, 'parent_relationship')}
              >
                {relationships.map((item) => (
                  <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
                ))}
              </Select>
            </div>
          </div>

          <Divider />

          <div className="grid grid-cols-3 gap-4">
            <Input
              label="Contraseña del representante"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              type={isVisible ? "text" : "password"}
              value={form.parent_password}
              onValueChange={v => onChange(v, 'parent_password')}
              endContent={visibilityBtn}
            />
            <Input
              label="Confirmar contraseña"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              type={isVisible ? "text" : "password"}
              value={form.parent_confirm_password}
              onValueChange={v => onChange(v, 'parent_confirm_password')}
              endContent={visibilityBtn}
            />
          </div>

        </div>
      </ModalBody>
      <ModalFooter>
        <Button variant="light" onPress={onClose}>Cerrar</Button>
        <Button className="bg-green" color="primary" onPress={submit}>Guardar</Button>
      </ModalFooter>
    </>
  )
}

const useForm = (currentUser) => {
  const initialForm = {
    photo: {},
    photoUrl: '',
    name: '',
    lastname: '',
    document_type_id: '',
    document: '',
    phonecode_id: '',
    phone: '',
    email: '',
    gender_id: '',
    // formulario de representantes
    parent_id: '',
    parent_name: '',
    parent_lastname: '',
    parent_document_type_id: '',
    parent_document: '',
    parent_phonecode_id: '',
    parent_phone: '',
    parent_email: '',
    parent_birthdate: '',
    parent_relationship: '',
    parent_password: '',
    parent_confirm_password: '',
    hasFile: true,
  };
  const user = useSelector(state => state.user);
  const [form, setForm] = useState(initialForm);
  const [debounceValue, setDebounceValue] = useState('');
  const [parents, setParents] = useState([]);
  const [genders, setGenders] = useState([]);
  const [phoneCodes, setPhoneCodes] = useState([]);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [relationships, setRelationships] = useState([]);

  const onChange = (value, target) => {
    if (target === 'photo' && !!value) {
      setForm(s => ({ ...s, photoUrl: URL.createObjectURL(value) }));
    }


    setForm(s => ({ ...s, [target]: value }));
  }


  const onError = (msg) => {
    toast.error(msg);
    return false;
  }

  const getSelects = async () => {
    const toSelect = (items) => items.map(x => ({ ...x, value: String(x.id), label: x.name }));
    const toSelectCodePhone = (items) => items.map(x => ({ ...x, value: String(x.id), label: x.name, url: x.url }));

    try {
      const selects = await UsersService.school.getSelects({ user_id: user.id });
      setPhoneCodes(toSelectCodePhone(selects.phonecodes));
      setDocumentTypes(toSelect(selects.document_types));
      setGenders(toSelect(selects.genders));
      setRelationships(toSelect(selects.reperesentative_relationships));

    } catch (error) {
      toast.error(String(error) || 'Ocurrió un error inesperado');
      return false;
    }
  }

  const isValidForm = () => {
    if (!form.photoUrl) {
      onError('Debe subir una foto del estudiante');
      return false;
    }
    if (!form.name) {
      onError('Debe indicar el nombre del estudiante');
      return false;
    }
    if (!form.lastname) {
      onError('Debe indicar el apellido del estudiante');
      return false;
    }
    if (!form.document_type_id) {
      onError('Debe indicar el tipo de documento');
      return false;
    }
    if (!form.document) {
      onError('Debe indicar el número de documento');
      return false;
    }
    if (!form.phonecode_id) {
      onError('Debe indicar el código de telefono');
      return false;
    }
    if (!form.phone) {
      onError('Debe indicar el número telefono');
      return false;
    }
    if (!form.email) {
      onError('Debe indicar el correo');
      return false;
    }
    if (!form.email.match(/^[A-Za-z0-9._%+-]+@[a-zA-Z_]+?\.[a-zA-Z]{2,}$/)) {
      onError('El correo debe tener un formato válido');
      return false;
    }

    return true;
  }

  const isValidParentForm = () => {


    if (!form.parent_name) {
      onError('Debe indicar el nombre del representante');
      return false;
    }

    if (!form.parent_lastname) {
      onError('Debe indicar el apellido del representante');
      return false;
    }

    if (!form.parent_document_type_id) {
      onError('Debe indicar el tipo de documento');
      return false;
    }


    if (!form.parent_document) {
      onError('Debe indicar el número de documento');
      return false;
    }

    if (!form.parent_phonecode_id) {
      onError('Debe indicar el código de telefono');
      return false;
    }

    if (!form.parent_phone) {
      onError('Debe indicar el número de telefono');
      return false;
    }

    if (!form.parent_email) {
      onError('Debe indicar el correo');
      return false;
    }

    if (!form.parent_birthdate) {
      onError('Debe indicar la fecha de nacimiento');
      return false;
    }

    if (!form.parent_email.match(/^[A-Za-z0-9._%+-]+@[a-zA-Z_]+?\.[a-zA-Z]{2,}$/)) {
      onError('El correo del reoresentante tener un formato válido');
      return false;
    }

    if (!form.parent_relationship) {
      onError('Debe indicar la relación del representante');
      return false;
    }

    if (!form.parent_id && form.parent_password.trim().length < 6) {
      onError('La constraseña debe tener al menos 6 caracteres');
      return false;
    }

    if (form.parent_password !== form.parent_confirm_password) {
      onError('Las contraseñas no coinciden');
      return false;
    }

    return true;
  }

  const onSubmit = async () => {
    if (!isValidForm() || !isValidParentForm()) return;
    try {
      let numericFields = ['document_type_id', 'gender_id', 'phonecode_id']
      const formattedData = formatNumericFields(form, numericFields);
      const data = { ...formattedData, user_id: user.id }


      currentUser
        ? await TeacherStudentSerivce.student.updateStudent({ ...data, id: currentUser.id })
        : await TeacherStudentSerivce.student.createStudent(data);
      toast.success(`Usuario ${currentUser ? 'editado' : 'creado'} correctamente`);
      return true;

    } catch (error) {
      onError(String(error));
      return false;
    }
  }

  useEffect(() => {
    if (!!currentUser) {
      const parent = currentUser?.representatives?.length > 0 ? currentUser.representatives[0].parent : null;
      const relationship = currentUser?.representatives?.length > 0 ? currentUser.representatives[0] : null;
      setForm({
        photo: {},
        photoUrl: !!currentUser?.photo ? fromPhotos(currentUser.photo) : '',
        name: currentUser?.name,
        lastname: currentUser?.lastname,
        document_type_id: String(currentUser?.document_type_id || ''),
        document: currentUser?.document,
        gender_id: String(currentUser?.gender_id || ''),
        phonecode_id: String(currentUser?.phonecode_id || ''),
        phone: currentUser?.phone,
        email: currentUser?.email,
        hasFile: true,

        // para padres
        parent_id: parent?.id,
        parent_name: parent?.name,
        parent_lastname: parent?.lastname,
        parent_document_type_id: String(parent?.document_type_id || ''),
        parent_document: parent?.document,
        parent_phonecode_id: String(parent?.phonecode_id || ''),
        parent_phone: parent?.phone,
        parent_birthdate: parent?.birthdate || '',
        parent_email: parent?.email,
        parent_relationship: String(relationship?.relationship_id || ''),
      })
    }
  }, [])


  /* useEffect(() => {
    const parentsData = parents.map((x) => JSON.stringify({ user_id: x.id, relationship_id: x.relationship_id }));
    setForm(s => ({ ...s, representatives: parentsData }));
  }, [parents]) */

  useEffect(() => {
    getSelects();
  }, []);

  return {
    form,
    onChange,
    onSubmit,
    parents,
    phoneCodes,
    documentTypes,
    relationships,
    currentUser: user,
    debounceValue,
    genders
  }
}

export default ModalCreateParent;

